import {getGridDefaultValue,getStyleDefaultValue,getLayoutDefaultValue} from "../../../utils/configuration/defaultSchema/schema.util";
import {COMPONENT_SCHEMA, EVENTS_SCHEMA} from '../../../utils/configuration/schema'

export const gridDefaultSchema = (data) => {
    const {componentName,componentId,isPage} = data;
    return {
        component: {
            [COMPONENT_SCHEMA.ID]: `${componentName}${componentId !== '' ? '_' : ''}${componentId}`,
            [COMPONENT_SCHEMA.SOURCE]: '',
        },
        style: getStyleDefaultValue(data),
        layout: getLayoutDefaultValue(data),
        grid: getGridDefaultValue(data),
        events: []
    }
}